import { useMemo, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

const TOOLBAR_OPTIONS = [
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link", "image"],
  ["clean"],
];

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Reutilizável em outras telas de conteúdo rico no futuro — não é específico de Notas de
// Atualização além do endpoint de upload recebido via prop.
export default function RichTextEditor({ value, onChange, idNotaAtualizacao, disabled }) {
  const quillRef = useRef(null);
  const snackbar = useSnackbar();

  const modules = useMemo(() => {
    const imageHandler = async () => {
      if (!idNotaAtualizacao) {
        snackbar.showMessage("Salve a nota antes de inserir imagens.", {
          severity: "warning",
        });
        return;
      }

      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/png,image/jpeg,image/webp");
      input.click();

      input.onchange = async () => {
        const file = input.files?.[0];
        if (!file) return;

        try {
          const base64 = await fileToBase64(file);
          const res = await Api.post(
            "upload-imagem",
            "releaseNotesDigitalApi",
            {
              idNotaAtualizacao,
              nomeArquivo: file.name,
              tipoConteudo: file.type,
              arquivoBase64: base64,
            },
            true
          );

          const url = res?.Result;
          if (!url) {
            snackbar.showMessage("Não foi possível enviar a imagem.", {
              severity: "error",
            });
            return;
          }

          const editor = quillRef.current?.getEditor();
          const range = editor?.getSelection(true);
          editor?.insertEmbed(range?.index ?? 0, "image", url);
        } catch (error) {
          snackbar.showMessage(error?.toString() || "Erro ao enviar imagem", {
            severity: "error",
          });
        }
      };
    };

    return {
      toolbar: {
        container: TOOLBAR_OPTIONS,
        handlers: { image: imageHandler },
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNotaAtualizacao]);

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      value={value || ""}
      onChange={onChange}
      modules={modules}
      readOnly={disabled}
    />
  );
}
